/* Griptec "How grip works" landing page.
   - [data-gw-reveal]: diagrams (curve, bars, tack scale) animate in when scrolled
     into view. They render complete by default; JS only "arms" them, and never
     when reduced motion is requested.
   - [data-gw-tabs]: sport picker. Without JS every sport panel shows stacked.
   - In-text [n] citations scroll to and flash the matching reference.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('[data-gw-reveal]').forEach(function (el) {
      if (el.dataset.gwRevealInit) return;
      el.dataset.gwRevealInit = '1';
      // Don't arm anything already on screen at load — it would flash empty.
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return;
      el.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        el.classList.add('is-in', 'is-drawn');
        io.disconnect();
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-gw-tabs]').forEach(function (wrap) {
      if (wrap.dataset.gwTabsInit) return;
      wrap.dataset.gwTabsInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = wrap.querySelector('.gw-panels');
      if (!tabs.length || !panels) return;
      panels.classList.add('is-tabbed');

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });

      // Deep link: #grip-rugby opens that sport.
      var fromHash = location.hash && wrap.querySelector('[role="tab"][data-slug="' + location.hash.slice(1) + '"]');
      select(fromHash || tabs[0], false);
    });
  }

  function flashRef(hash) {
    if (!/^#source-\d+$/.test(hash || '')) return;
    var t = document.getElementById(hash.slice(1));
    if (!t) return;
    t.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    t.classList.remove('is-flash');
    void t.offsetWidth;
    t.classList.add('is-flash');
    setTimeout(function () { t.classList.remove('is-flash'); }, 1800);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#source-"]');
    if (!a) return;
    e.preventDefault();
    history.replaceState(null, '', a.getAttribute('href'));
    flashRef(a.getAttribute('href'));
  });

  // "In this guide" rail: on wide screens it's fixed beside the chapters. Show it
  // once the hero has gone, hide it after the last chapter, mark the current
  // chapter (aria-current), and switch colours over ink / yellow bands.
  function initRail() {
    var rail = document.querySelector('[data-gw-rail]');
    if (!rail || rail.dataset.gwRailInit) return;
    rail.dataset.gwRailInit = '1';
    var hero = document.querySelector('.gw-hero');
    var links = Array.prototype.slice.call(rail.querySelectorAll('.gw-rail__a'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var bands = Array.prototype.slice.call(document.querySelectorAll('.gw:not(.gw-hero)'));
    var wide = window.matchMedia('(min-width: 1200px)');
    var ticking = false;
    // Compact panel starts closed on small screens; the wide rail is always open.
    if (!wide.matches) rail.open = false;

    function update() {
      ticking = false;
      if (wide.matches && !rail.open) rail.open = true;
      var vh = window.innerHeight;
      var current = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= vh * 0.35) current = i; });
      links.forEach(function (a, i) {
        if (i === current) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      if (!wide.matches) { rail.classList.remove('is-shown', 'is-on-ink', 'is-on-yellow'); return; }
      var last = bands[bands.length - 1];
      var heroGone = !hero || hero.getBoundingClientRect().bottom < 80;
      var r = rail.getBoundingClientRect();
      var before = !last || last.getBoundingClientRect().bottom > r.bottom + 40;
      rail.classList.toggle('is-shown', heroGone && before);
      var mid = r.top + r.height / 2;
      var behind = null;
      bands.forEach(function (b) { var br = b.getBoundingClientRect(); if (br.top <= mid && br.bottom >= mid) behind = b; });
      rail.classList.toggle('is-on-ink', !!behind && behind.classList.contains('gw--ink'));
      rail.classList.toggle('is-on-yellow', !!behind && behind.classList.contains('gw--yellow'));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // On small screens the panel is a <details>: close it after picking a chapter.
    links.forEach(function (a) { a.addEventListener('click', function () { if (!wide.matches) rail.open = false; }); });
    update();
  }

  function initAll() {
    initReveals(document);
    initTabs(document);
    initRail();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
